// Centralized list of supported locales/languages for the app
// Update this file to add/remove supported languages

export const SUPPORTED_LOCALES = [
  "en", "es", "fr", "pt-BR", "pt-PT","de", "it", "pl", "ru", "ar", "he"
];

// Optionally, a mapping for display names (used in LanguageSwitch)
export const LOCALE_LABELS = {
  en: "English",
  es: "Español",
  fr: "Français",
  "pt-BR": "Português (BR)",
  "pt-PT": "Português (PT)",
  de: "Deutsch",
  it: "Italiano",
  pl: "Polski",
  ru: "Русский",
  ar: "عربي",
  he: "עברית"
};
